// Класс для работы платежной системы
class PaymentSystem {
    constructor(data) {
        this.id = data.id || null
        this.active = (data.active !== undefined) ? data.active : false
        this.code = data.code || null
        this.type = data.type || null
        this.direction = data.direction || null
        this.currency_code = data.currency_code || null
        this.image = data.image || null
        this.titles = data.titles || { en: '-', ru: '-' }
        this.descriptions = data.descriptions || { en: '-', ru: '-' }
        this.sort = data.sort || 0
        this.comissions = data.comissions || { percent: 0, fix: 0 }
        this.limits = data.limits || { min: 0, max: 0 }
        this.recipient_fields = data.recipient_fields || []
        this.recipient_fields_required = data.recipient_fields_required || []
        this.get_bank_codes = data.get_bank_codes || []
        this.send_bank_codes = data.send_bank_codes || []
        this.kyc_required = data.kyc_required || false
        this.active_from = (data.active_from !== undefined && data.active_from !== null) ? data.active_from : null
        this.active_to = (data.active_to !== undefined && data.active_to !== null) ? data.active_to : null
        this.timers = {
            expired: data.timers && data.timers.expired ? data.timers.expired : null,
            process: data.timers && data.timers.process ? data.timers.process : null,
            confirm: data.timers && data.timers.confirm ? data.timers.confirm : null
        }
    }

    static format(data, helper) {
        return helper.formatPaymentSystems(data)
    }

    // получение платежной системы по коду
    static getPaySysByCode(code, allPaySys) {
        if (!code || !allPaySys) return null
        const arrList = Object.values(allPaySys)
        for (let i = 0; i < arrList.length; i++) {
            if (arrList[i].code == code) return arrList[i]
        }
        return null
    }

    // получение банка по коду
    static getBankByCode(code, type, banks_obj) {
        if (!code || !banks_obj) return null
        if (!banks_obj) return null
        const arrList = Object.values(banks_obj)
        for (let i = 0; i < arrList.length; i++) {
            if (arrList[i].code == code && arrList[i].type == type) return arrList[i]
        }
        return null
    }

    toObject() {
        return {
            id: this.id,
            active: this.active,
            code: this.code,
            type: this.type,
            direction: this.direction,
            currency_code: this.currency_code,
            image: this.image,
            titles: this.titles,
            descriptions: this.descriptions,
            sort: this.sort,
            comissions: this.comissions,
            limits: this.limits,
            recipient_fields: this.recipient_fields,
            recipient_fields_required: this.recipient_fields_required,
            get_bank_codes: this.get_bank_codes,
            send_bank_codes: this.send_bank_codes,
            kyc_required: this.kyc_required,
            active_from: this.active_from,
            active_to: this.active_to,
            timers: this.timers
        }
    }
}

// Класс-обёртка для списка платежных систем
class PaymentSystemList {
    constructor(list) {
        this.items = (list || []).map(item => new PaymentSystem(item))
    }

    // Получение списка из Vuex стора
    static GetListFromStore(store) {
        if(!store) return []
        if(!(store instanceof Object)) return []
        return store.getters.GetPaymentSystems || []
    }

    // Получение данных с API
    static async FetchFromApi(store) {
        const res = await store.dispatch('GetPaymentSystems')
        if (res && res.data && Array.isArray(res.data)) {
            const arr = res.data.map(item => (item instanceof PaymentSystem ? item.toObject() : new PaymentSystem(item).toObject()))
            store.commit('setPayment', arr)
            return arr
        }
        return []
    }

    // Получение списка с проверкой в сторе и запросом к API
    static async GetList(store) {
        let list = this.GetListFromStore(store)
        if (!list || !list.length) {
            list = await this.FetchFromApi(store)
        }
        return list
    }

    toArray() {
        return this.items
    }

    getByCode(code) {
        return this.items.find(item => item.code === code) || null
    }
    
    GetTitle(code, lang='en') {
        if(!code) return '-'
        if(!this.items || this.items.length==0) return '-'
        const pays = this.items.find(item => item.code === code)
        if (!pays) return '-'
        return pays.titles[lang] || pays.titles['en'] || '-'
    }

    GetImage(code) {
        if(!code) return null
        if(!this.items || this.items.length==0) return null
        const pays = this.items.find(item => item.code === code)
        if (!pays) return null
        return pays.image || null
    }

    GetDescription(code, lang='en') {
        if(!code) return '-'
        if(!this.items || this.items.length==0) return '-'
        const pays = this.items.find(item => item.code === code)
        if (!pays) return '-'
        return pays.descriptions[lang] || pays.descriptions['en'] || '-'
    }

    // Группировка платежных систем по типу с сортировкой внутри группы
    static GroupByType(paysList) {
        if (!paysList || !paysList.length) return []
        let grouped = {}
        for (let i = 0; i < paysList.length; i++) {
            const item = paysList[i]
            const code = (item.pay_sys && item.pay_sys.code) ? item.pay_sys.code : 'other'
            if (!grouped[code]) grouped[code] = []
            grouped[code].push(item)
        }
        // Сортировка внутри каждой группы: сначала по sort (по возрастанию), затем по limits.max (по убыванию)
        const getMaxLimit = (item) => {
            if (item.bank?.limits?.max != null) return Number(item.bank.limits.max)
            if (item.pay_sys?.limits?.max != null) return Number(item.pay_sys.limits.max)
            return 0
        }
        return Object.entries(grouped).map(([type, items]) => {
            const sorted = items.slice().sort((a, b) => {
                const sortA = a.sort !== undefined ? a.sort : 9999
                const sortB = b.sort !== undefined ? b.sort : 9999
                if (sortA !== sortB) return sortA - sortB // по возрастанию sort
                const maxA = getMaxLimit(a)
                const maxB = getMaxLimit(b)
                return maxB - maxA // по убыванию limits.max
            })
            return { type, items: sorted }
        })
    }

    // Определение платежных систем
    static async RecognizePays(rateObj, type, store, filterCodes = null) {
        if (!rateObj || !type || !store) return []

        let result = []

        const banks = (type == 'get') ? rateObj.get_bank_codes : rateObj.send_bank_codes
        const pays = (type == 'get') ? rateObj.pays_get_codes : rateObj.pays_send_codes
        if (!pays || pays.length == 0) return []

        let item = {}

        const all_pay_sys = await PaymentSystemList.GetList(store)
        if(!all_pay_sys || all_pay_sys.length == 0) return []

        const all_banks = BankList.GetListFromStore(store)
        if(!all_banks || all_banks.length == 0) return []

        // Сначала проходим по платежным системам
        for (let i = 0; i < pays.length; i++) {
            const payCode = pays[i]
            const pay = PaymentSystem.getPaySysByCode(payCode, all_pay_sys)
            if (!pay || !pay.code || !pay.type) continue

            // Определяем коды банков для фильтрации по типу платежной системы
            const getPayBankCodes = (pay.get_bank_codes && Array.isArray(pay.get_bank_codes)) ? pay.get_bank_codes : []
            const sendPayBankCodes = (pay.send_bank_codes && Array.isArray(pay.send_bank_codes)) ? pay.send_bank_codes : []
            const payBankCodes = (type == 'get') ? getPayBankCodes : sendPayBankCodes

            // направдение
            if (pay.direction && (pay.direction != type && pay.direction!='both')) continue

            item = {}

            if (pay.type != 'merchant') {

                // Добавляем платежку без банка
                if(payBankCodes.length == 0){
                    item = {
                        type: 'paysystem',
                        pay_sys: {
                            code: pay.code,
                            type: pay.type,
                            currency_code: (pay.currency_code) ? pay.currency_code : null,
                            comissions: (pay.comissions) ? pay.comissions : { percent: 0, fix: 0 },
                            limits: (pay.limits) ? pay.limits : { min: 0, max: 99999999 },
                            image: (pay.image) ? pay.image : null,
                            titles: (pay.titles) ? pay.titles : { en: '-', ru: '-' },
                            descriptions: (pay.descriptions) ? pay.descriptions : { en: '-', ru: '-' },
                            kyc_required: (pay.kyc_required !== undefined) ? pay.kyc_required : false,
                            timers: (pay.timers) ? pay.timers : { expired: null, process: null, confirm: null },
                            recipient_fields: (pay.recipient_fields) ? pay.recipient_fields : [],
                            recipient_fields_required: (pay.recipient_fields_required) ? pay.recipient_fields_required : [],
                        },
                        bank: {},
                        sort: (pay.sort) ? pay.sort : 0,
                        kyc_required: (pay.kyc_required !== undefined) ? pay.kyc_required : false,
                    }
                    result.push(item)
                } else {
                    for (let j = 0; j < payBankCodes.length; j++) {
                        const bankCode = payBankCodes[j]
                        if (!bankCode) continue

                        // Получаем банк из общего списка банков
                        const bank = PaymentSystem.getBankByCode(bankCode, pay.code, all_banks)
                        if (!bank || !bank.code || !bank.type) continue

                        // для atm проверяем наличие списка сумм
                        if(filterCodes && !filterCodes.includes(bank.type)) continue

                        // Получаем лимиты банка из курса (get_banks или send_banks)
                        let rateBank = null
                        if (type == 'get') {
                            rateBank = (rateObj.get_banks || []).find(b => b.code == bank.code && b.type == bank.type)
                        } else {
                            rateBank = (rateObj.send_banks || []).find(b => b.code == bank.code && b.type == bank.type)
                        }

                        // Итоговые лимиты: сначала из rateBank, если нет — из bank
                        const minLimit = (rateBank && rateBank.min !== undefined) ? rateBank.min : (bank.limits && bank.limits.min !== undefined ? bank.limits.min : 0)
                        const maxLimit = (rateBank && rateBank.max !== undefined) ? rateBank.max : (bank.limits && bank.limits.max !== undefined ? bank.limits.max : 99999999)

                        item = {
                            type: 'paysystem',
                            pay_sys: {
                                code: pay.code,
                                type: pay.type,
                                currency_code: (pay.currency_code) ? pay.currency_code : null,
                                comissions: (pay.comissions) ? pay.comissions : { percent: 0, fix: 0 },
                                limits: (pay.limits) ? pay.limits : { min: 0, max: 99999999 },
                                image: (pay.image) ? pay.image : null,
                                titles: (pay.titles) ? pay.titles : { en: '-', ru: '-' },
                                descriptions: (pay.descriptions) ? pay.descriptions : { en: '-', ru: '-' },
                                kyc_required: (pay.kyc_required !== undefined) ? pay.kyc_required : false,
                                timers: (pay.timers) ? pay.timers : { expired: null, process: null, confirm: null },
                                recipient_fields: (pay.recipient_fields) ? pay.recipient_fields : [],
                                recipient_fields_required: (pay.recipient_fields_required) ? pay.recipient_fields_required : [],
                            },
                            bank: {
                                code:           bank.code,
                                type:           bank.type,
                                currency_code:  (bank.currency_code) ? bank.currency_code : null,
                                comissions:     (bank.comissions) ? bank.comissions : { percent: 0, fix: 0 },
                                limits: {
                                    min: minLimit,
                                    max: maxLimit
                                },
                                image:                      (bank.image) ? bank.image : null,
                                titles:                     (bank.titles) ? bank.titles : { en: '-', ru: '-' },
                                descriptions:               (bank.descriptions) ? bank.descriptions : { en: '-', ru: '-' },
                                recipient_fields:           (bank.recipient_fields) ? bank.recipient_fields : [],
                                recipient_fields_required:  (bank.recipient_fields_required) ? bank.recipient_fields_required : [],
                                amount_list:                (bank.amount_list) ? bank.amount_list : [],
                            },
                            // порядок: сначала sort банка (из админки), иначе sort платёжной системы
                            sort: bank?.sort ? Number(bank.sort) : (pay.sort ? pay.sort : 0),
                            kyc_required: (pay.kyc_required !== undefined) ? pay.kyc_required : false,
                        }
                        result.push(item)
                    }
                }
            } else {

                // Затем по банкам
                if (banks.length == 0) continue

                for (let j = 0; j < banks.length; j++) {
                    const bankCode = banks[j]
                    if (!bankCode) continue

                    // Получаем банк из общего списка банков
                    const bank = PaymentSystem.getBankByCode(bankCode, payCode, all_banks)
                    if (!bank || !bank.code || !bank.type) continue

                    // для atm проверяем наличие списка сумм
                    if(filterCodes && !filterCodes.includes(bank.type)) continue

                    // Получаем лимиты банка из курса (get_banks или send_banks)
                    let rateBank = null
                    if (type == 'get') {
                        rateBank = (rateObj.get_banks || []).find(b => b.code == bank.code && b.type == bank.type)
                    } else {
                        rateBank = (rateObj.send_banks || []).find(b => b.code == bank.code && b.type == bank.type)
                    }

                    // Итоговые лимиты: сначала из rateBank, если нет — из bank
                    const minLimit = (rateBank && rateBank.min !== undefined) ? rateBank.min : (bank.limits && bank.limits.min !== undefined ? bank.limits.min : 0)
                    const maxLimit = (rateBank && rateBank.max !== undefined) ? rateBank.max : (bank.limits && bank.limits.max !== undefined ? bank.limits.max : 99999999)

                    item = {
                        type: 'bank',
                        pay_sys: {
                            code: pay.code,
                            type: pay.type,
                            comissions: (pay.comissions) ? pay.comissions : { percent: 0, fix: 0 },
                            image: (pay.image) ? pay.image : null,
                            titles: (pay.titles) ? pay.titles : { en: '-', ru: '-' },
                            descriptions: (pay.descriptions) ? pay.descriptions : { en: '-', ru: '-' },
                            kyc_required: (pay.kyc_required !== undefined) ? pay.kyc_required : false,
                            timers: (pay.timers) ? pay.timers : { expired: null, process: null, confirm: null },
                            recipient_fields: (pay.recipient_fields) ? pay.recipient_fields : [],
                            recipient_fields_required: (pay.recipient_fields_required) ? pay.recipient_fields_required : [],
                        },
                        bank: {
                            code: bank.code,
                            type: bank.type,
                            comissions: (bank.comissions) ? bank.comissions : { percent: 0, fix: 0 },
                            titles: (bank.titles) ? bank.titles : { en: '-', ru: '-' },
                            descriptions: (bank.descriptions) ? bank.descriptions : null,
                            image: (bank.image) ? bank.image : null,
                            recipient_fields: (bank.recipient_fields) ? bank.recipient_fields : [],
                            recipient_fields_required: (bank.recipient_fields_required) ? bank.recipient_fields_required : [],
                            amount_list: (bank.amount_list) ? bank.amount_list : [],
                            limits: {
                                min: minLimit,
                                max: maxLimit
                            },
                        },
                        // порядок: сначала sort банка (из админки), иначе sort платёжной системы
                        sort: bank?.sort ? Number(bank.sort) : (pay.sort ? pay.sort : 0),
                    }
                    result.push(item)
                }
            }
        }

        // удалить дубли из объекта объектов
        let unique = {}
        // result.forEach(function(i) {
        //     if(!unique[i.code]) {
        //         unique[i.code] = i
        //     }
        // })
        result = Object.values(result)
        // сортируем по sort
        result.sort((a, b) => a.sort - b.sort)
        // сортировка по limits max по убыванию
        // result.sort((a, b) => b.limits.max - a.limits.max)
        return result
    }
}

class Bank {
    constructor(data) {
        this.id = data.id || null
        this.active = (data.active !== undefined) ? data.active : false
        this.code = data.code || null
        this.type = data.type || null
        this.titles = data.titles || { en: '-', ru: '-' }
        this.currency_code = data.currency_code || null
        this.descriptions = data.descriptions || { en: '-', ru: '-' }
        this.image = data.image || null
        this.comissions = data.comissions || { percent: 0, fix: 0 }
        this.limits = data.limits || { min: 0, max: 0 }
        this.recipient_fields = data.recipient_fields || []
        this.recipient_fields_required = data.recipient_fields_required || []
        this.amount_list = data.amount_list || []
        this.sort = data.sort || 0
        this.time = data.time || null
    }

    static GetAmountList(pays) {
        if (!pays || !pays.amount_list || pays.amount_list.length == 0) return []
        return pays.amount_list.map(item => item.toString())
    }

    toObject() {
        return {
            id: this.id,
            active: this.active,
            code: this.code,
            type: this.type,
            titles: this.titles,
            currency_code: this.currency_code,
            descriptions: this.descriptions,
            image: this.image,
            comissions: this.comissions,
            limits: this.limits,
            recipient_fields: this.recipient_fields,
            recipient_fields_required: this.recipient_fields_required,
            amount_list: this.amount_list,
            sort: this.sort,
            time: this.time
        }
    }
}

class BankList {
    constructor(list) {
        this.items = (list || []).map(item => new Bank(item))
    }

    // Получение списка из Vuex стора
    static GetListFromStore(store) {
        if(!store) return []
        if(!(store instanceof Object)) return []
        const list = store.getters.GetBanks || []
        return (list || []).filter(item => item && (item.active === true || item.active === 1 || item.active === '1'))
    }

    // Получение данных с API
    static async FetchFromApi(store) {
        const res = await store.dispatch('GetBanks')
        if (res && res.data && Array.isArray(res.data)) {
            const arr = res.data.map(item => (item instanceof Bank ? item.toObject() : new Bank(item).toObject()))
            store.commit('setBanks', arr)
            return arr
        }
        return []
    }

    // Получение списка с проверкой в сторе и запросом к API
    static async GetList(store) {
        let list = this.GetListFromStore(store)
        if (!list || !list.length) {
            list = await this.FetchFromApi(store)
        }
        return (list || []).filter(item => item && (item.active === true || item.active === 1 || item.active === '1'))
    }

    GetTitle(bankCode, lang='en') {
        if(!bankCode) return '-'
        if(!this.items || this.items.length==0) return '-'
        const bank = this.items.find(item => item.code === bankCode)
        if (!bank) return '-'
        return bank.titles[lang] || bank.titles['en'] || '-'
    }

    GetImage(bankCode) {
        if(!bankCode) return null
        if(!this.items || this.items.length==0) return null
        const bank = this.items.find(item => item.code === bankCode)
        if (!bank) return null
        return bank.image || null
    }

    GetDescription(bankCode, lang='en') {
        if(!bankCode) return '-'
        if(!this.items || this.items.length==0) return '-'
        const bank = this.items.find(item => item.code === bankCode)
        if (!bank) return '-'
        return bank.descriptions[lang] || bank.descriptions['en'] || '-'
    }

    toArray() {
        return this.items
    }
}

export { PaymentSystem, PaymentSystemList, Bank, BankList }
